/**
 * Derives up to two uppercase initials from a display name or email, splitting on
 * whitespace, dots and `@`. Returns '' for empty input.
 */
export function toInitials(name: string | null | undefined): string {
  if (!name) return '';
  return name
    .split(/[\s.@]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join('');
}

export function getUrlExtensionType(
  url: string,
): 'web' | 'word' | 'ppt' | 'excel' | 'pdf' | 'file' {
  const wordExtensions = ['doc', 'docx'];
  const pptExtensions = ['ppt', 'pptx'];
  const excelExtensions = ['xls', 'xlsx', 'csv'];
  const pdfExtensions = ['pdf'];
  const htmlExtensions = ['html'];

  try {
    const pathname = new URL(url).pathname.toLowerCase();
    const extension = pathname.split('.').pop();

    if (!extension || htmlExtensions.includes(extension) || extension === pathname) return 'web';
    if (pdfExtensions.includes(extension)) return 'pdf';
    if (wordExtensions.includes(extension)) return 'word';
    if (pptExtensions.includes(extension)) return 'ppt';
    if (excelExtensions.includes(extension)) return 'excel';
    return 'file';
  } catch {
    return 'file';
  }
}
